/**
 * Wix → New site URL mapping for SEO migration.
 *
 * Each entry maps an old Wix path to its closest equivalent on the new app.
 * Used by <LegacyRoutes /> in App.js to emit client-side 301-equivalent
 * redirects (Navigate replace) while preserving link equity via canonical tags.
 *
 * For a TRUE HTTP 301 at the edge, the same paths should be configured as
 * Cloudflare Page Rules on the production domain (see /app/MIGRATION_SEO.md).
 */

// Static (exact) path map. Source paths must be lowercase, no query string.
export const STATIC_REDIRECTS = {
  // Pages "Montélimar" SEO landing
  "/voyance-guidances-a-montelimar": "/services",
  "/pranic-healing-a-montelimar": "/services",
  "/bilan-numerologique-a-montelimar": "/services",
  "/purifications-lieux-et-personnes-a-montelimar": "/services",
  "/boutique-spirituelle-montelimar": "/boutique",

  // Wix navigation / utility pages
  "/quelle-prestation-choisir": "/services",
  "/quelle-prestation-choisir-1": "/services",
  "/services-8": "/services",
  "/copie-de-purification-personne": "/services",
  "/séjours-spirituels": "/evenements",
  "/sejours-spirituels": "/evenements",
  "/event-list": "/evenements",
  "/book-online": "/booking",
  "/contact": "/qui-suis-je",
  "/payment-request-page": "/",
  // Note: /a-propos and /blog already exist on the new site (1:1).
};

/**
 * Map a Wix /service-page/<slug> to the best new destination.
 * Workshops / events get sent to /evenements, everything else to /services.
 */
export function resolveServicePage(slug) {
  if (!slug) return "/services";
  const s = slug.toLowerCase();
  if (
    s.startsWith("atelier") ||
    s.startsWith("soiree") ||
    s.startsWith("soirée") ||
    s.startsWith("salon") ||
    s.includes("escapade")
  ) {
    return "/evenements";
  }
  if (s.includes("consultation") && (s.includes("distance") || s.includes("a-distance"))) {
    return "/voyance-a-distance";
  }
  return "/services";
}

/**
 * Lookup helper used by <LegacyStaticRedirect />.
 * Normalises trailing slashes and is case-insensitive on the path key.
 */
export function lookupStaticRedirect(pathname) {
  if (!pathname) return null;
  const clean = pathname.replace(/\/+$/, "").toLowerCase();
  return STATIC_REDIRECTS[clean] || null;
}
